import { render, staticRenderFns } from "./DataSourceSelection.vue?vue&type=template&id=c6df67c4&"
import script from "./DataSourceSelection.vue?vue&type=script&lang=js&"
export * from "./DataSourceSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports